<template>
    <div class="circle">
        <ul class="circle-container">
            <li
                class="circle-button"
                :class="{ selected: index == selecionado }"
                v-for="(item, index) in conteudo"
                :key="index"
                @click="selectItem(index)"
            >
                {{ item.titulo }}
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    props: ["conteudo", "selecionado"],
    methods: {
        selectItem(value) {
            this.$emit("selectItem", value);
        },
    },
};
</script>
<style lang="scss" scoped>
.circle {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: bottom;
    width: 556px;
    margin-bottom: 80px;
    margin-left: 10%;
    &-container {
        background-size: cover;
        @include on-circle(
            $item-count: 6,
            $circle-size: 25em,
            $item-size: 4em,
            $top-position: 50%,
            $left-position: 28%
        );
        margin: 5em auto 2em;
        background-image: url("~@/assets/img/mandala-bg.png");
    }
    &-button {
        user-select: none;
        height: 40px;
        width: 240px;
        padding: 18px 5px 0 5px;
        color: white;
        font-weight: bold;
        background-color: $color-cerulean;
        border-radius: 50px;
        // background-image: url('~@/assets/img/mandala-button.png');
        // background-size: contain;
        // background-repeat: no-repeat;

        cursor: pointer !important;
        user-select: none;
        &:nth-child(1) {
            margin-top: -30px;
        }
        &:nth-child(2) {
            margin-top: 4px;
        }
        &:nth-child(3) {
            margin-top: -70px;
        }
        &:nth-child(4) {
            margin-top: -40px;
        }
        &:nth-child(5) {
            margin-top: -70px;
        }
        &:nth-child(6) {
            margin-top: 4px;
        }
    }
    .selected {
        // background-image: url('~@/assets/img/mandala-button-selected.png');
        // background-size: contain;
        // background-repeat: no-repeat;
        background-color: $color-yellow;

        font-weight: bold;
        transition: 0.4s;
    }
}

@media (max-width: 660px) {
    .circle {
        width: 100%;
        &-container {
            background-size: cover;
            @include on-circle(
                $item-count: 6,
                $circle-size: 13em,
                $item-size: 4em,
                $top-position: 50%,
                $left-position: 20%
            );
            margin: 3em auto 3em;
            background-image: url("~@/assets/img/mandala-bg.png");
        }
        &-button {
            user-select: none;
            height: 20px;
            width: 140px;
            padding: 6px 0;
            color: white;
            // background-image: url('~@/assets/img/mandala-button.png');
            // background-size: contain;
            // background-repeat: no-repeat;
            background-color: $color-cerulean;
            border-radius: 50px;
            font-size: 0.8rem;

            cursor: pointer !important;
            user-select: none;
            &:nth-child(1) {
                margin-top: -32px;
                margin-left: 0px;
            }
            &:nth-child(2) {
                margin: 0;
                margin-top: -5px;
                margin-left: 20px;
            }
            &:nth-child(3) {
                margin-top: -15px;
                margin-left: 20px;
            }
            &:nth-child(4) {
                margin: 0;
            }
            &:nth-child(5) {
                margin-top: -15px;
                margin-left: -20px;
            }
            &:nth-child(6) {
                margin: 0;
                margin-top: -5px;

                margin-left: -20px;
            }
        }
    }
}
@media (max-width: 330px) {
    .circle {
        width: 100%;
        &-container {
            background-size: cover;
            @include on-circle(
                $item-count: 6,
                $circle-size: 12em,
                $item-size: 4em,
                $top-position: 40%,
                $left-position: 18%
            );
            margin: 3em auto 3em;
            background-image: url("~@/assets/img/mandala-bg.png");
        }
        &-button {
            user-select: none;
            height: 20px;
            width: 120px;
            padding: 8px 5px 0 5px;
            color: white;
            font-weight: bold;
            // background-image: url('~@/assets/img/mandala-button.png');
            // background-size: contain;
            // background-repeat: no-repeat;
            background-color: $color-cerulean;
            border-radius: 50px;

            cursor: pointer !important;
            user-select: none;
            &:nth-child(1) {
                margin-top: -15px;
            }
            &:nth-child(2) {
                margin-top: 15px;
            }
            &:nth-child(3) {
                margin-top: 0;
            }
            &:nth-child(4) {
                margin-top: 20px;
            }
            &:nth-child(5) {
                margin-top: 0;
            }
            &:nth-child(6) {
                margin-top: 15px;
            }
        }
    }
}
</style>